import React from "react";
import { Select } from "antd";
import IconFont from "@/components/icon";
import { useTranslation } from "react-i18next";
import { isNumber } from "lodash";
const { Option } = Select;

interface RepatSelectProps {
  onChange: (value: number) => void;
  value: number;
  minutespan: number | null | undefined;
}

export function judgeRepeat(minutespan: number | null | undefined, repeat: number) {
  // console.log("judgeRepeat minutespan-->>", repeat, minutespan);
  if (!isNumber(minutespan)) return false;
  let isDisabled = false;
  switch (repeat) {
    case 1:
    case 2:
      if (minutespan > 1 * 1440) {
        isDisabled = true;
      }
      break;
    case 3:
      if (minutespan > 7 * 1440) {
        isDisabled = true;
      }
      break;
    case 4:
      if (minutespan > 14 * 1440) {
        isDisabled = true;
      }
      break;
    case 5:
      if (minutespan > 30 * 1440) {
        isDisabled = true;
      }
      break;
    case 6:
      if (minutespan > 365 * 1440) {
        isDisabled = true;
      }
      break;
    default:
      break;
  }
  return isDisabled;
}

function areEqual(prevProps: RepatSelectProps, nextProps: RepatSelectProps) {
  // 如果prevProps和nextProps完全相等，返回true，否则返回false
  if (prevProps.value === nextProps.value && prevProps.minutespan === nextProps.minutespan) {
    return true;
  }
  return false;
}

const RepatSelect = React.memo(({ onChange, value, minutespan }: RepatSelectProps) => {
  const { t } = useTranslation("calendar");
  // console.log("RepatSelect minutespan-->>", value, minutespan);
  return (
    <Select
      defaultValue={value}
      showArrow={true}
      value={value}
      suffixIcon={<IconFont type="iconicon_down" className="anticon-down icon-more icon-toggle" />}
      style={{
        width: value === 0 ? "100%" : "120px"
      }}
      onChange={onChange}
      className="calendar-custom-select calendar-custom-select-arrow"
    >
      <Option className="calendar-custom-select-option" value={0}>
        {t("no-repeat")}
      </Option>
      <Option
        className="calendar-custom-select-option"
        value={1}
        disabled={judgeRepeat(minutespan, 1)}
      >
        {t("Every working day")}
      </Option>
      <Option
        className="calendar-custom-select-option"
        value={2}
        disabled={judgeRepeat(minutespan, 1)}
      >
        {t("Every day")}
      </Option>
      <Option
        className="calendar-custom-select-option"
        value={3}
        disabled={judgeRepeat(minutespan, 3)}
      >
        {t("Every week")}
      </Option>
      <Option
        className="calendar-custom-select-option"
        value={4}
        disabled={judgeRepeat(minutespan, 4)}
      >
        {t("Every two weeks")}
      </Option>
      <Option
        className="calendar-custom-select-option"
        value={5}
        disabled={judgeRepeat(minutespan, 5)}
      >
        {t("Every month")}
      </Option>
      <Option
        className="calendar-custom-select-option"
        value={6}
        disabled={judgeRepeat(minutespan, 6)}
      >
        {t("Every year")}
      </Option>
    </Select>
  );
}, areEqual);

export default RepatSelect;
